export default class PhoneTypes {
    static ANDROID = 0
    static IOS = 1

    static display = [
        'Android',
        'iOS'
    ]
}